(function () {
  'use strict';

  var ENHANCED_ATTR = 'data-nine-bottom-klaviyo-ready';
  var CONSENT_SELECTOR = '[data-nine-bottom-consent]';
  var MERGED_CLASS = 'nine-bottom__form-row--merged';

  function ensureDataLayer() {
    window.dataLayer = window.dataLayer || [];
  }

  function getEmail(form) {
    var input =
      form.querySelector('input[type="email"][name="email"]') ||
      form.querySelector('input[type="email"]');
    return input && input.value ? String(input.value).trim() : '';
  }

  function getGaTags(root) {
    return {
      module: root.getAttribute('data-ga-module') || 'nine_bottom',
      contentName: root.getAttribute('data-ga-content-name') || ''
    };
  }

  /**
   * @param {{ root: Element, status: string, email?: string }} opts
   */
  function pushSubscribeGa4(opts) {
    var tags = getGaTags(opts.root);
    var email = opts.email !== undefined ? opts.email : '';
    ensureDataLayer();
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'subscribe',
      event_parameters: {
        module: "nine_naphat_subscription",
        status: opts.status,
        email: email
      }
    });
  }

  function getForm(root) {
    return root.querySelector('.klaviyo-form form, .klaviyo-form-RYd5be form');
  }

  function getSubmitButton(form) {
    var row = form.querySelector('[data-testid="form-row"]:first-of-type');
    return row ? row.querySelector('button') : null;
  }

  function setSubmitLocked(form, locked) {
    var button = getSubmitButton(form);
    if (!button) return;
    if (locked) {
      button.classList.add('is-submit-locked');
      button.setAttribute('aria-disabled', 'true');
    } else {
      button.classList.remove('is-submit-locked');
      button.removeAttribute('aria-disabled');
    }
  }

  function getRichTextHtml(row) {
    var rich = row.querySelector('.klaviyo-form-richtext');
    return rich ? rich.innerHTML : '';
  }

  function enhanceKlaviyo(root) {
    if (root.querySelector(CONSENT_SELECTOR)) {
      root.setAttribute(ENHANCED_ATTR, 'true');
      return;
    }

    if (root.getAttribute(ENHANCED_ATTR) === 'true') return;

    var form = getForm(root);
    if (!form) return;

    var rows = form.querySelectorAll('[data-testid="form-row"]');
    if (rows.length < 3) return;

    var row1 = rows[0];
    var row2 = rows[1];
    var row3 = rows[2];

    if (!row2.querySelector('.klaviyo-form-richtext') && !row3.querySelector('.klaviyo-form-richtext')) {
      return;
    }

    if (form.querySelector(CONSENT_SELECTOR)) {
      root.setAttribute(ENHANCED_ATTR, 'true');
      return;
    }

    var consentRow = document.createElement('div');
    consentRow.className = 'nine-bottom__consent-row';
    consentRow.setAttribute('data-nine-bottom-consent', '');

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'nine-bottom__consent-check';
    toggle.setAttribute('aria-pressed', 'false');
    toggle.setAttribute('aria-label', 'ยอมรับเงื่อนไขการรับข่าวสาร');

    var checkbox = document.createElement('span');
    checkbox.className = 'nine-bottom__checkbox';
    checkbox.setAttribute('aria-hidden', 'true');
    toggle.appendChild(checkbox);

    var textWrap = document.createElement('div');
    textWrap.className = 'nine-bottom__consent-text';
    textWrap.innerHTML = getRichTextHtml(row2) + getRichTextHtml(row3);

    consentRow.appendChild(toggle);
    consentRow.appendChild(textWrap);

    row1.parentNode.insertBefore(consentRow, row2);

    row2.classList.add(MERGED_CLASS);
    row3.classList.add(MERGED_CLASS);

    toggle.addEventListener('click', function () {
      var checked = toggle.classList.toggle('is-checked');
      toggle.setAttribute('aria-pressed', checked ? 'true' : 'false');
      setSubmitLocked(form, !checked);
    });

    form.addEventListener(
      'click',
      function (event) {
        var button = getSubmitButton(form);
        if (!button || !button.contains(event.target)) return;

        var emailVal = getEmail(form);

        if (!toggle.classList.contains('is-checked')) {
          pushSubscribeGa4({
            root: root,
            status: 'fail',
            email: emailVal
          });
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }

        pushSubscribeGa4({
          root: root,
          status: 'success',
          email: emailVal
        });
      },
      true
    );

    form.addEventListener(
      'submit',
      function (event) {
        if (!toggle.classList.contains('is-checked')) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      },
      true
    );

    setSubmitLocked(form, true);
    root.setAttribute(ENHANCED_ATTR, 'true');
  }

  function watchKlaviyo(root) {
    var debounceTimer;

    function tryEnhance() {
      if (!root.querySelector(CONSENT_SELECTOR)) {
        root.removeAttribute(ENHANCED_ATTR);
      }
      enhanceKlaviyo(root);
    }

    tryEnhance();

    var observer = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(tryEnhance, 120);
    });

    observer.observe(root, { childList: true, subtree: true });
  }

  function initScope(scope) {
    var targets = scope.querySelectorAll('[data-nine-bottom-klaviyo]');
    Array.prototype.forEach.call(targets, watchKlaviyo);
  }

  function onSectionLoad(event) {
    var scope = event.target;
    if (!scope || !scope.querySelector) return;
    initScope(scope);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initScope(document);
  });

  document.addEventListener('shopify:section:load', onSectionLoad);
})();
